import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { WsProvider } from "@/context/WsContext";
import { FavProvider } from "@/context/FavContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import BrowsePage from "@/pages/BrowsePage";
import GigDetailPage from "@/pages/GigDetailPage";
import SellerProfilePage from "@/pages/SellerProfilePage";
import ProfilePage from "@/pages/ProfilePage";
import RequestsPage from "@/pages/RequestsPage";
import NewRequestPage from "@/pages/NewRequestPage";
import RequestDetailPage from "@/pages/RequestDetailPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import DashboardPage from "@/pages/DashboardPage";
import CreateGigPage from "@/pages/CreateGigPage";
import OrderDetailPage from "@/pages/OrderDetailPage";
import MessagesPage from "@/pages/MessagesPage";
import EarningsPage from "@/pages/EarningsPage";
import OnboardingPage from "@/pages/OnboardingPage";
import FavoritesPage from "@/pages/FavoritesPage";
import BuyerHomePage from "@/pages/BuyerHomePage";
import AdminPage from "@/pages/AdminPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AuthCallback from "@/pages/AuthCallback";
import LoginPage from "@/pages/LoginPage";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  // Synchronous check for OAuth session_id in URL fragment
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/browse" element={<BrowsePage />} />
        <Route path="/category/:slug" element={<BrowsePage />} />
        <Route path="/gig/:id" element={<GigDetailPage />} />
        <Route path="/seller/:id" element={<SellerProfilePage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/dashboard/new-gig" element={<CreateGigPage key="new" />} />
        <Route path="/dashboard/edit-gig/:id" element={<CreateGigPage key="edit" />} />
        <Route path="/order/:id" element={<OrderDetailPage />} />
        <Route path="/messages" element={<MessagesPage />} />
        <Route path="/messages/:otherId" element={<MessagesPage />} />
        <Route path="/earnings" element={<EarningsPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/requests" element={<RequestsPage />} />
        <Route path="/requests/new" element={<NewRequestPage />} />
        <Route path="/requests/:id" element={<RequestDetailPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/favorites" element={<FavoritesPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/buyer/home" element={<BuyerHomePage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/login" element={<LoginPage />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App noise-overlay">
      <AuthProvider>
        <CurrencyProvider>
          <FavProvider>
            <WsProvider>
              <BrowserRouter>
                <AppRouter />
                <Toaster position="top-right" richColors closeButton />
              </BrowserRouter>
            </WsProvider>
          </FavProvider>
        </CurrencyProvider>
      </AuthProvider>
    </div>
  );
}
